import React from 'react';
import { Calendar } from 'lucide-react';
export function TimelineSection() {
  return <section className="py-16 px-4 bg-[#111]" data-id="element-210">
      <div className="max-w-3xl mx-auto" data-id="element-211">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-white flex items-center justify-center gap-3" data-id="element-212">
          <Calendar className="w-8 h-8 text-amber-500" data-id="element-213" />
          Qué pasa cuando entrás
        </h2>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-amber-800/50 before:to-transparent" data-id="element-214">
          {/* Week 1 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-215">
            <div className="flex items-center justify-center w-10 h-10 rounded-full border border-amber-700 bg-amber-600 text-black shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-216">
              <span className="font-bold" data-id="element-217">1</span>
            </div>
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-[#1a1a1a] p-4 rounded border border-gray-800 shadow" data-id="element-218">
              <div className="flex items-center justify-between space-x-2 mb-1" data-id="element-219">
                <div className="font-bold text-white" data-id="element-220">Semana 1</div>
              </div>
              <div className="text-gray-400" data-id="element-221">
                Entendés exactamente qué hacer.
              </div>
            </div>
          </div>

          {/* Week 2 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-222">
            <div className="flex items-center justify-center w-10 h-10 rounded-full border border-amber-700 bg-amber-600 text-black shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-223">
              <span className="font-bold" data-id="element-224">2</span>
            </div>
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-[#1a1a1a] p-4 rounded border border-gray-800 shadow" data-id="element-225">
              <div className="flex items-center justify-between space-x-2 mb-1" data-id="element-226">
                <div className="font-bold text-white" data-id="element-227">Semana 2</div>
              </div>
              <div className="text-gray-400" data-id="element-228">
                Ya podés explicar el proceso como profesional.
              </div>
            </div>
          </div>

          {/* Week 3-4 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-229">
            <div className="flex items-center justify-center w-10 h-10 rounded-full border border-amber-700 bg-amber-600 text-black shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-230">
              <span className="font-bold" data-id="element-231">4</span>
            </div>
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-[#1a1a1a] p-4 rounded border border-gray-800 shadow" data-id="element-232">
              <div className="flex items-center justify-between space-x-2 mb-1" data-id="element-233">
                <div className="font-bold text-white" data-id="element-234">Semana 3–4</div>
              </div>
              <div className="text-gray-400" data-id="element-235">
                Podés estar cotizando tu primer trabajo.
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-236">
          <p className="text-3xl font-black text-amber-500" data-id="element-237">
            De 0 a tu primer trabajo cobrado.
          </p>
        </div>
      </div>
    </section>;
}